<template>
  <div class="last-updated" v-if="distance">
    <i class="material-icons">&#xE192;</i>
    <p>{{ $t({ path: 'overview.last_updated', args: { distance: distance } }) }}</p>
  </div>
</template>

<script>
import distanceInWordsToNow from 'date-fns/distance_in_words_to_now';
import progress from 'services/Progress'

export default {
  data() {
    return {
      distance: null,
    };
  },

  computed: {
    lastUpdated () {
      return progress.lastUpdated
    }
  },

  created() {
    setInterval(this.update, 10000);
  },

  watch: {
    lastUpdated () {
      this.update()
    }
  },

  methods: {
    update () {
      this.distance = distanceInWordsToNow(this.lastUpdated);
    }
  }
}

</script>

<style lang="scss">

</style>